import { useMemo } from "react";
import { useSidebarOptional } from "components/common/Sidebar/Sidebar";

/**
 * Left inset for viewport-fixed AI overlays so they do not cover the app sidebar.
 * The widths come from `--sidebar-width` / `--sidebar-width-icon`, which
 * SidebarProvider sets from the shared shell constants (252px and 60px).
 * Below md the sidebar is a sheet, so overlays start at the left edge.
 */
export function usePageOverlayInsetClass(): string {
  const sidebar = useSidebarOptional();

  return useMemo(() => {
    if (!sidebar || sidebar.isMobile) {
      return "left-0";
    }
    return sidebar.state === "expanded"
      ? "left-[var(--sidebar-width)]"
      : "left-[var(--sidebar-width-icon)]";
  }, [sidebar]);
}
